import { Link, useLoaderData, useNavigate } from "react-router-dom";
import styles from "./adpage.module.css";
import { Alternative } from "../../Models/AlternativeModel";
import AlternativeLevel from "../../components/AlternativeLevel/AlternativeLevel";
import Tag from "./Tag/Tag";
import { arrow_right, bioBased, star } from "../../assets/icons";
import DocumentButton from "./DocumentLink/DocumentLink";
import { useContext, useEffect, useState } from "react";
import { AccountContext } from "../../Store/Account.store";
import { WizardFormData } from "../../Models/WizardModel";
import ConfirmDialog from "./ConfirmationModal/ConfirmDialog";
import AdminModal from "./AdminModal/AdminModal";
import { deleteAlternative, updateAlternativeLevel, updateIsPopular, publishAlternative, getAlternativeByUrl, UpdateOwner } from "../../Api/Services/Alternative";
import LoadingIcon from "../../components/LoadingIcon/LoadingIcon";
import OwnerModal from "./OwnerModal/OwnerModal";
import SinlistModal from "./SinlistModal/SinlistModal";
import MarketplaceGroupsModal from "./MarketplaceGroupsModal/MarketplaceGroupsModal";

interface AdPageProps {
  alternativeData?: Alternative;
  isPreview: boolean;
}

export default function AdPage({ alternativeData, isPreview }: AdPageProps) {
  const {accountData} = useContext(AccountContext);
  const [data, setData] = useState<Alternative>(alternativeData != undefined ? alternativeData : useLoaderData() as Alternative);
  const placeholderImage = "/api/file/logotype/" + data.logotype?.id;
  const fileBaseUrl = "/api/file/attachment/";
  const [fileUrl, setFileUrl] = useState<string>('');
  const navigate = useNavigate();
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const [openAdminModal, setOpenAdminModal] = useState<boolean>(false);
  const [openPublishDialog, setOpenPublishDialog] = useState<boolean>(false);  const [openOwnerModal, setOpenOwnerModal] = useState<boolean>(false);
  const [openSinlist, setOpenSinlist] = useState<boolean>(false);
  const [openMarketplaceGroups, setOpenMarketplaceGroups] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);


  useEffect(() => {
      if (data.logotype?.fileData) {
        var reader = new FileReader();
        reader.onload = function(event) {
          setFileUrl(event.target?.result as string);
        };
        reader.readAsDataURL(data.logotype?.fileData);
      }
  }, []);
    const handleOpenDialogs = (dialog: string) => {
    setOpenDialog(dialog === "delete" ? !openDialog : false);
    setOpenAdminModal(dialog === "admin" ? !openAdminModal : false);
    setOpenPublishDialog(dialog === "publish" ? !openPublishDialog : false);
    setOpenOwnerModal(dialog === "owner" ? !openOwnerModal : false);
    setOpenSinlist(dialog === "sinlist" ? !openSinlist : false);
    setOpenMarketplaceGroups(dialog === "marketplacegroups" ? !openMarketplaceGroups : false);
  }

  const publishAd = (id: number) => {
    publishAlternative(id).then((response) => {
      if (response.success) {
          window.location.pathname = `/alternative${data.publicUrl}`;
      } else {
        alert("Error could not publish alternative: " + response.message);
      }
    });
  }

  const deleteAd = () => {
    deleteAlternative(data.id).then((response) => {
      if (response.success) {
          window.location.pathname = `/`;
      } else {
        alert("Error could not delete alternative");
      }
    });
  }

  const editAd = (e: any) => {
    e.preventDefault();
    setLoading(true);
    getAlternativeByUrl(data.publicUrl?.slice(1, data.publicUrl.length) ?? "", false).then((response) => {
      if (response.id == 0) {
        getAlternativeByUrl(data.publicUrl?.slice(1, data.publicUrl.length) ?? "", true).then((response) => {
          const newAdData: WizardFormData = {
            wizardStep: 1,
            initialSetup: true,
            alternativeFilter: [],
            editMode: true,
            adData: {
              id: response.id,
              title: response.title,
              description: response.description ?? "",
              alternativeToCategories: response.alternativeToCategories,
              supplementaryInformation: response.supplementaryInformation ?? "",
              useCategories: response.useCategories,
              sectorCategories: response.sectorCategories,
              certificationCategories: response.certificationCategories,
              isBioBased: response.isBioBased,
              casNumber: response.casNumber ?? "",
              technicalDataSheet: response.technicalDataSheet,
              safetyDataSheet: response.safetyDataSheet,
              additionalDocuments: response.additionalDocuments,
              additionalInformation: response.additionalInformation ?? "",
              companyName: response.companyName ?? "",
              companyGroupId: response.companyGroupId ?? 0,
              companyWebsite: response.companyWebsite ?? "",
              contactName: response.contactName ?? "",
              contactEmail: response.contactEmail ?? "",
              logotype: {
                fileData: new File([], ""),
                fileName: response.logotype?.fileName ?? "",
                mimeType: "",
                id: response.logotype?.id ?? 0,
              },
              alternativeLevel: response.alternativeLevel ?? 0
          }};
          navigate("/advertise-your-alternative", {state: newAdData});
        });
      }else{
        const newAdData: WizardFormData = {
          wizardStep: 1,
          initialSetup: true,
          alternativeFilter: [],
          editMode: true,
          adData: {
            id: response.id,
            title: response.title,
            description: response.description ?? "",
            alternativeToCategories: response.alternativeToCategories,
            supplementaryInformation: response.supplementaryInformation ?? "",
            useCategories: response.useCategories,
            sectorCategories: response.sectorCategories,
            certificationCategories: response.certificationCategories,
            isBioBased: response.isBioBased,
            casNumber: response.casNumber ?? "",
            technicalDataSheet: response.technicalDataSheet,
            safetyDataSheet: response.safetyDataSheet,
            additionalDocuments: response.additionalDocuments,
            additionalInformation: response.additionalInformation ?? "",
            companyName: response.companyName ?? "",
            companyGroupId: response.companyGroupId ?? 0,
            companyWebsite: response.companyWebsite ?? "",
            contactName: response.contactName ?? "",
            contactEmail: response.contactEmail ?? "",
            logotype: {
              fileData: new File([], ""),
              fileName: response.logotype?.fileName ?? "",
              mimeType: "",
              id: response.logotype?.id ?? 0,
            },
            alternativeLevel: response.alternativeLevel ?? 0
        }};
        navigate("/advertise-your-alternative", {state: newAdData});
      }
    });
  }

  const adminUpdate = (level: number, popular: boolean) => {
    if (level != data?.alternativeLevel) {
      updateAlternativeLevel(Number(data?.id), level).then((response) => {
        if (!response.success) {
          alert(response.message)
        }else{
            setData((prevState) => ({ ...prevState, alternativeLevel: level }));
            handleOpenDialogs("admin");
        }
      })
    }
    
    if (popular != data?.isPopular) {
      updateIsPopular(Number(data?.id), popular).then((response) => {
        if (!response.success) {
          alert(response.message)
        }else{
          setData((prevState) => ({ ...prevState, isPopular: popular }));
          handleOpenDialogs("admin");
        }
      })
    }
  }
  const updateAdOwner = (owner: string) => {
    UpdateOwner(data.id, owner).then((data) => {
      if (data.success) {
        handleOpenDialogs("owner");
          setData((prevState) => ({ ...prevState, createdBy: owner }));
      } else {
          alert(data.message);
      }
    });
  }

  return (
    <div className={`${styles.ad_container} container ${isPreview ? styles.is_preview : ''}`}>
      {loading && LoadingIcon()}
      <div className={styles.ad_content}>
        <div className={styles.ad_image}></div>
        <div className={styles.titlecard}>
          {!isPreview &&
            <AlternativeLevel level={data.alternativeLevel!} isPublished={data.isPublished} />
          }
          <h1 className={styles.title}>{data.title}</h1>
          <div className={styles.tag_container}>
            {data.isPopular && <Tag icon={star} text={"Popular alternative"} />}
            {data.isBioBased && <Tag icon={bioBased} text={"Bio-based"} />}
          </div>
        </div>
        <h2>About this alternative</h2>
        <p className={styles.description}>{data.description}</p>
        <h2>Alternative to</h2>
        <div className={styles.alternative_to}>
          {data.alternativeToCategories &&
            data.alternativeToCategories.map((category, index) => (
              <p key={category.id}>
                {category.name}
                {index < data.alternativeToCategories.length - 1 && ";"}
              </p>
            ))}
        </div>
        <h2>Documents</h2>
        <div className={styles.documents_container}>
          {data.technicalDataSheet && (
            <DocumentButton
              text="Technical Data Sheet"
              link={fileBaseUrl + data.technicalDataSheet.id}
              isPreview={isPreview}
              fileName={data.technicalDataSheet.fileName}
            />
          )}
          {data.safetyDataSheet && (
            <DocumentButton
              text="Safety Data Sheet"
              link={fileBaseUrl + data.safetyDataSheet.id}
              isPreview={isPreview}
              fileName={data.safetyDataSheet.fileName}
            />
          )}
          {data.additionalDocuments &&
            data.additionalDocuments.map((doc, index) => (
              <DocumentButton key={index} text={doc.fileName} link={fileBaseUrl + doc.id} isPreview={isPreview} fileName={doc.fileName} />
            ))}
        </div>
        <h2>Use</h2>
        <div className={styles.alternative_to}>
          {data.useCategories &&
            data.useCategories.map((category, index) => (
              <p key={category.id}>
                {category.name}
                {index < data.useCategories.length - 1 && ";"}
              </p>
            ))}
        </div>
        <h2>Sector</h2>
        <div className={styles.alternative_to}>
          {data.sectorCategories &&
            data.sectorCategories.map((category, index) => (
              <p key={category.id}>
                {category.name}
                {index < data.sectorCategories.length - 1 && ";"}
              </p>
            ))}
        </div>
        <h2>Third party labels and certifications</h2>
        <div>
          {data.certificationCategories &&
            data.certificationCategories.map((category) => (
              <p key={category.id}>
                {category.name}
              </p>
            ))}
        </div>
        <h2>Additional information</h2>
        <p className={styles.description}>{data.additionalInformation}</p>
      </div>
      <div>
        {accountData.roles.includes("Administrator") && !isPreview &&
          <div className={styles.adminButtons}>
            {!data.isPublished &&
              <button className={`${styles.publishButton} button`} onClick={() => handleOpenDialogs("publish")}>Publish</button>
            }
            {openPublishDialog &&
              <ConfirmDialog infoText="Are you sure you want to publish" title={data.title} handleConfirm={() => publishAd(data.id)} handleCancel={() => handleOpenDialogs("publish")}/>
            }
            <button className={`${styles.publishButton} button`} onClick={() => handleOpenDialogs("admin")}>Change alternative level</button>
            {openAdminModal &&
              <AdminModal alternativeLevel={Number(data.alternativeLevel)} ispopular={data.isPopular} handleUpdate={(alternativeLevel, ispopular) =>{adminUpdate(alternativeLevel, ispopular)}} handleClose={() => handleOpenDialogs("admin")}/>
            }
            <button className={`${styles.publishButton} button`} onClick={() => handleOpenDialogs("owner")}>Change owner</button>
            {openOwnerModal && <OwnerModal defaultOwner={data.createdBy} handleSave={(e) => updateAdOwner(e)} handleClose={() => handleOpenDialogs("owner")} />}            <button type="button" className="button" onClick={() => handleOpenDialogs("sinlist")}>SIN list</button>
            {openSinlist && <SinlistModal id={data.id} handleClose={() => handleOpenDialogs("sinlist")} />}
            <button type="button" className="button" onClick={() => handleOpenDialogs("marketplacegroups")}>Marketplace Groups</button>
            {openMarketplaceGroups && <MarketplaceGroupsModal id={data.id} handleClose={() => handleOpenDialogs("marketplacegroups")} />}

          </div>
        }

        <div className={styles.company_card}>
          <img
            src={isPreview == true && data.logotype?.id === 0 ? fileUrl : placeholderImage}
            alt="company logo"
            className={styles.logo}
          />
          <h4>SUPPLIER</h4>
          <p className={styles.company_name}>{data.companyName}</p>
          {data.companyWebsite &&
          <>
            <h4>WEBSITE</h4>
            <a href={data.companyWebsite.startsWith("http") ? data.companyWebsite : "//" + data.companyWebsite} 
              className={`${styles.company_website} ${isPreview ? 'no-click' : ''}`}>
              {data.companyWebsite}
            </a>
          </>
          }
          <div className={styles.action_container}>
            {data.alternativeLevel !== 1 ? ( // alternativelevel 1 is bronze according to AlternativeLevel.tsx
              <> {/* Show buttons if alternative level is not bronze */}
                <Link to={`/alternative${data.publicUrl}/request-more-information`} className={`button ${styles.request_info} ${isPreview ? 'no-click' : ''}`} onClick={(e) => {e.preventDefault(); navigate(`/alternative${data.publicUrl}/request-more-information`, {state: {adName: data.title, adUrl: data.publicUrl, contactEmail: data.contactEmail}})}}>
                  Request more information
                </Link>
                <Link to={`/alternative${data.publicUrl}/request-sample`} className={`${styles.request_sample} button ${isPreview ? 'no-click' : ''}`} onClick={(e) => {e.preventDefault(); navigate(`/alternative${data.publicUrl}/request-sample`, {state: {adName: data.title, adUrl: data.publicUrl, contactEmail: data.contactEmail}})}}>
                  Request a quote or sample
                </Link>
              </>
            ) : (data.companyWebsite && ( // else show "Visit supplier" button
                <a href={data.companyWebsite.startsWith("http") ? data.companyWebsite : "//" + data.companyWebsite} 
                  className={`button ${styles.visit_supplier} ${isPreview ? 'no-click' : ''}`}>
                  Visit supplier
                </a>
              )
            )}
            <div className={styles.see_more_container}>
              <Link
                to={`/search?q=${data.companyName}`}
                className={`${styles.see_more} ${isPreview ? 'no-click' : ''}`}
              >
                See more from this supplier
              </Link>
              {arrow_right}
            </div>
          </div>
        </div>
        {accountData.isauthenticated && (data.createdBy == accountData.username || accountData.roles.includes("Administrator")) && !isPreview ?
        <div className={styles.owner_buttons}>
            <button onClick={() => handleOpenDialogs("delete")} className="button">Delete</button>
            <Link to={'/advertise-your-alternative'} onClick={(e) => editAd(e)} className="button">Edit</Link>
            {openDialog &&
              <ConfirmDialog infoText="Are you sure you want to delete" title={data.title} handleConfirm={() => deleteAd()} handleCancel={() => handleOpenDialogs("delete")}/>
            }
          </div>
          : null
        }
      </div>
    </div>
  );
}
